import {React,useState} from 'react';
import {TextField, CircularProgress, Box ,Grid,Typography} from "@material-ui/core";
import {Table,
        Fecha,
        Accordion,
        AccordionDetails,
        AccordionSummary,
        Loading,
        ExpandMoreIcon,
        objestados,
        regex_solo_numeros,
        usuario_habilitado_sede,
        deshabilitar} from './index.js'

import {usePatrocinado} from '../../hooks/usePatrocinado.js'
import { Button, Spinner } from '@material-tailwind/react';
import Main from '../../../../componentes/Main.js';
import { RowCopia } from '../RowCopia.js';

export const InfoPatrocinado = ({id,cabecera,setData,usuario,finalizar,snackbar,puedeEditarse,cambiarStatus})=>{
    const {error,loading,loading2,procesando,datosDelTramite,status_actual_tramite,expanded,
        handleChange,acta_regional,setActa_regional,fechaAR,handleChangeFechaAR,setActa_cdn,fechaACDN,
        handleChangeFechaACDN,inicioActualizacionTramite,actualizarTramite,touched,
        acta_cdn} =usePatrocinado(cabecera,id,setData,usuario,snackbar);
    const [copia,setCopia] = useState(false)

    const copiarLink = (tipo,link) =>{
        navigator.clipboard.writeText(link)
                setCopia(true)
                setTimeout(() => {
                    setCopia(false)
                }, 1000);
    }

    if(error){
        return <p>{JSON.stringify(error)}</p>
    }

    if(loading || loading2 || procesando){
        return <Main center alinear>
                    <div className='flex flex-col justify-center items-center h-[calc(100vh-10rem)]'>
                        <Spinner className="h-12 w-12" />
                        <span className="cargando font-semibold text-[15px]">Cargando...</span>
                    </div>
                </Main>
     }

    if(!datosDelTramite){
       
        return <div>
              <Spinner className="h-12 w-12" />
             <p>Cargando solicitud</p>
        </div>
    }


    return <Box id="solicitud-proceso" sx={{marginRight:'auto',marginLeft:'auto',padding:'5px',borderRadius:'10px',border:'solid 1px gray'}}>
            
            {status_actual_tramite==objestados.procRegion.nombre && usuario.perfil=='region' && <Accordion expanded={expanded === 'instrucciones'} onChange={handleChange('instrucciones')}>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="instrucciones-content"
                style={{borderBottom:'solid 1px gray',justifyContent:'center',alignItems:'center',background:'rgb(228 228 231)'}}
                id="instrucciones-header"
                >
                    <h3>Instrucciones para procesar una solicitud de un nuevo ministro</h3> 
                </AccordionSummary>
                <AccordionDetails>
                </AccordionDetails>
            </Accordion>}
            <Accordion expanded>
                <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="generales-content"
                style={{borderBottom:'solid 1px gray',justifyContent:'center',alignItems:'center',background:'rgb(228 228 231)'}}
                id="generales-header"
                >
                    <h3>Datos personales</h3> 
                </AccordionSummary>
                <AccordionDetails>
                <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Box sx={{textAlign:'left'}}>
                    <Table className='sol-anexo'>
                            <tbody className='text-sm'>
                                <tr>
                                    <td>
                                        Nombre completo
                                    </td>
                                    <td>
                                    {datosDelTramite.nombre} {datosDelTramite.apellido}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        E-mail
                                    </td>
                                    <td>
                                    {datosDelTramite.email}
                                    </td>
                                </tr>                                
                                {/* <tr>
                                    <td>
                                        Sexo
                                    </td>
                                    <td>
                                    {datosDelTramite.sexo=="M" ? 'Hombre' : 'Mujer'}
                                    </td>
                                </tr> */}
                                <tr>
                                    <td>
                                        Link de continuación del trámite:
                                    </td>
                                    <td>
                                        
                                    {datosDelTramite.activo ? 'Activo' : 'Desactivado'}
                                    </td>
                                  
                                </tr>
                                      <RowCopia 
                                        titulo = "Puede copiar el link para reenviarlo al ministro"
                                        link = {`https://ministros.uad.digital/externos/temporal/${datosDelTramite._id}`}
                                    />                                
                            </tbody>
                        </Table>
                    </Box>  
                </Grid>
            </Grid>
                </AccordionDetails>
            </Accordion>
    </Box> 
}




